export const messages = {
  en: {
    maintainanceStandardItem: {
      title: 'Inspection Items',
      back: 'Back',
      add: 'Add',
      item: 'Inspection Item',
      id: 'ID',
      operation: 'Operation',
      delete: 'Delete',
      fetchError: 'Failed to fetch inspection items'
    },
    chooseMaintainanceStandardItem: {
      title: 'Select Inspection Items',
      searchPlaceholder: 'Enter inspection item',
      search: 'Search',
      reset: 'Reset',
      id: 'ID',
      item: 'Inspection Item',
      submit: 'Submit',
      cancel: 'Cancel',
      selectWarning: 'Please select at least one inspection item',
      submitSuccess: 'Added successfully',
      submitError: 'Failed to add inspection items',
      fetchError: 'Failed to fetch available inspection items'
    },
    deleteMaintainanceStandardItem: {
      title: 'Confirm Operation',
      confirmMessage: 'Are you sure to delete this inspection item?',
      cancel: 'Cancel',
      confirm: 'Confirm Delete',
      deleteSuccess: 'Deleted successfully',
      deleteError: 'Failed to delete inspection item'
    }
  },
  zh: {
    maintainanceStandardItem: {
      title: '检查项',
      back: '返回',
      add: '添加',
      item: '检查项',
      id: '编号',
      operation: '操作',
      delete: '删除',
      fetchError: '获取检查项失败'
    },
    chooseMaintainanceStandardItem: {
      title: '选择检查项',
      searchPlaceholder: '输入检查项',
      search: '查询',
      reset: '重置',
      id: '编号',
      item: '检查项',
      submit: '提交',
      cancel: '取消',
      selectWarning: '请至少选择一项检查项',
      submitSuccess: '添加成功',
      submitError: '添加检查项失败',
      fetchError: '获取可选检查项失败'
    },
    deleteMaintainanceStandardItem: {
      title: '请确认您的操作',
      confirmMessage: '确定删除该检查项吗？',
      cancel: '点错了',
      confirm: '确认删除',
      deleteSuccess: '删除成功',
      deleteError: '删除检查项失败'
    }
  }
}